import '@ionic/core';
import { Component, h, Prop} from '@stencil/core';

import axios from 'axios';

@Component({
  tag: 'subscription-palette',
  styleUrl: 'subscription-palette.css',
  shadow: true
})
export class SubscriptionPalette {
    @Prop({ attribute: 'cohort-id' }) cohortId: number = 1000;
    @Prop({ attribute: 'search-query' }) searchQuery: string;

    private email = '';
    private baseURL: string = `https://api.probono.savvysuit.com/v2/`;

    private processForm = (event) => {
        event.preventDefault();

        const that = this;

        axios.post(`${this.baseURL}cohort/${this.cohortId}/subscribe`, {
            subscriber_query: this.searchQuery.substr(0, 1024),
            subscriber_email: this.email.substr(0, 250)
        })
        .then(function () {
            that.presentAlert('Success', 'Subscription created successfully', 'We\'ll let you know if any matching cases are posted.')
        })
        .catch(function (error) {
            console.error(error);
            that.presentAlert('Warning', 'Failed to ceate subscription', 'I was unable to save your subscription.  Please re-enter it and try again.')
        });
    }

    private presentAlert = (title: string, subtitle: string, message: string) => {
        const alert: any = document.createElement('ion-alert');
        alert.header = title;
        alert.subHeader = subtitle;
        alert.message = message;
        alert.buttons = ['OK'];

        document.body.appendChild(alert);
        return alert.present();
    }

    private updateVolunteerEmail = (e: any) => {
        this.email = e.target.value;
    }

    render() {
        return (
            <div id="SSPBCatalogSubscriptionPalette">
                <h2>Enter your preferences in the search above and sign up to get emails any time a case matches your search!</h2>
                <form onSubmit={((e) => this.processForm(e)).bind(this)}>
                    <ion-grid>
                        <ion-row align-items-center>
                            <ion-col>
                                <div>
                                    <ion-item>
                                        <ion-label position="floating">Enter your email address</ion-label>
                                        <ion-input aria-label='Email address' required type="email" inputmode="email" value={this.email} name="subscription_email" onIonChange={((event) => { this.updateVolunteerEmail(event) }).bind(this)}></ion-input>
                                    </ion-item>
                                </div>
                            </ion-col>
                            <ion-col>
                            <div>
                                <ion-button type="submit" fill="clear">
                                    <ion-icon name="save-sharp" slot="start" />
                                    Sign Up
                                </ion-button>
                            </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </form>
            </div>
        );
    }
}
